<template>
    <article class="recipe-listing-card col-12 col-md-6 col-lg-4">
        <a class="recipe-listing-card__link" v-bind:href="item.Url" v-bind:aria-label="displayAriaLabel">
            <div class="recipe-listing-card__media">
                <img class="recipe-listing-card__image"
                     v-bind:src="image"
                     v-bind:alt="imageAlt" />
            </div>

            <div class="recipe-listing-card__body">
                <div class="recipe-listing-card__categories" v-if="recipeTypes.length">
                    {{ recipeTypesText }}
                </div>

                <h3 class="recipe-listing-card__title">{{ item.Title }}</h3>

                <p class="recipe-listing-card__time" v-if="cookTime">
                    {{ cookTime }} min cook time
                </p>
            </div> 
        </a>

        <ul class="recipe-listing-card__pills" aria-label="Dairy ingredients" v-if="dairyTypes.length">
            <li class="recipe-listing-card__pill recipe-featured-collection-card__badge" v-for="tag in dairyTypes.slice(0, 4)" v-bind:key="tag.Text">
                <span class="recipe-listing-card__pill-icon"
                      v-bind:class="dairyTypeIconClass(tag)"
                      aria-hidden="true"></span>
                {{ tag.Text }}
            </li>
        </ul>
    </article>
</template>

<script>
    import imageOptimizer from '../../utils/image-optimizer';
    import { getCookTime, getDairyTypes, getRecipeTypes } from '../../utils/recipe-card';

    export default {
        props: ['item'],
        computed: {
            recipeTypes: function () {
                return getRecipeTypes(this.item);
            },
            dairyTypes: function () {
                return getDairyTypes(this.item);
            },
            recipeTypesText: function () {
                return this.recipeTypes.slice(0, 2).map((tag) => tag.Text.toUpperCase()).join(', ');
            },
            cookTime: function () {
                return getCookTime(this.item);
            },
            imageAlt: function () {
                return this.item.ImageAltText || this.item.Title;
            },
            displayAriaLabel: function () {
                return this.item.DisplayAriaLabel || this.item.Title;
            },
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')) {
                    if ($(window).width() < 768 && this.item.ImageMobile) {
                        return imageOptimizer.getOptimizedImageUrl(this.item.ImageMobile, 'webp');
                    }
                    else if (this.item.Image) {
                        return imageOptimizer.getOptimizedImageUrl(this.item.Image, 'webp');
                    }
                    else {
                        return '/content/images/default-recipe-image.png';
                    }
                }

                if ($(window).width() < 768 && this.item.ImageMobile) {
                    return imageOptimizer.getSanitizeMediaUrl(this.item.ImageMobile);
                }
                else if (this.item.Image) {
                    return imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                }

                return '/content/images/default-recipe-image.png';
            }
        },
        methods: {
            dairyTypeIconClass: function (tag) {
                const dairyType = (tag.Text || '').trim().toLowerCase().replace(/[\s-]+/g, '-');

                return `icon-${dairyType}`;
            }
        }
    }
</script>
